// extracted by mini-css-extract-plugin
export default {"button":"ButtonUp_button__GzQuK","hideButton":"ButtonUp_hideButton__YGvSW"};